import groupApi from '@/api/group';

const SET_GROUP_USERS = 'SET_GROUP_USERS';
const ADD_GROUP_USER = 'ADD_GROUP_USER';
const DELETE_GROUP_USER = 'DELETE_GROUP_USER';

const state = {
  users: []
};

const getters = {
  getGroupUsers: state => {
    return state.users;
  }
};

const mutations = {
  [SET_GROUP_USERS] (state, users) {
    state.users = users;
  },
  [ADD_GROUP_USER] (state, user) {
    state.users.push(user);
  },
  [DELETE_GROUP_USER] (state, id) {
    const index = state.users.map(e => e.id).indexOf(id);
    state.users.splice(index, 1);
  }
};

const actions = {
  retriveGroupUsers ({ commit }, { context, groupId }) {
    groupApi.getUsersOfGroup(context, groupId).then(users => {
      commit(SET_GROUP_USERS, users);
    });
  },
  addUserIntoGroup ({ commit }, { context, groupId, user }) {
    return new Promise((resolve, reject) => {
      groupApi.addUserIntoGroup(context, groupId, user.id).then(group => {
        commit(ADD_GROUP_USER, user);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  removeUserFromGroup ({ commit }, { context, groupId, user }) {
    return new Promise((resolve, reject) => {
      groupApi.removeUserFromGroup(context, groupId, user.id).then(group => {
        commit(DELETE_GROUP_USER, user.id);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  clearGroupUsers ({ commit }) {
    commit(SET_GROUP_USERS, []);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/groupUsers/index.js